import React from 'react';
import styles from './GoalsNotesAndDocuments.module.scss';
import ProgressNotes from '../../NotesAndDocuments/ProgressNotes/ProgressNotes';
import { useProgressNotesAPI } from '../../../CustomHooks/useProgressNotesAPI';
import GrowthPlanDocuments from './GrowthPlanDocuments/GrowthPlanDocuments';

type GaolNotesDocProps = {
  goalID?: number;
  isHistoryGoalData?: boolean;
};
const GoalsNotesAndDocuments = ({ goalID, isHistoryGoalData }: GaolNotesDocProps) => {
  const growthPlanAPI = useProgressNotesAPI('growthPlan');
  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.inner_wrapper}>
        <div className={styles.section_wrapper}>
          <ProgressNotes
            api={growthPlanAPI}
            type="growthPlan"
            goalId={goalID}
            isHistoryGoalData={isHistoryGoalData}
          />
        </div>
        <div className={styles.section_wrapper}>
          <GrowthPlanDocuments goalID={goalID} isHistoryGoalData={isHistoryGoalData} />
        </div>
      </div>
    </div>
  );
};

export default GoalsNotesAndDocuments;
